const labelColors = [
  {id:"red",color: "bg-red-400", ring: "ring-red-400",text: "text-red-600" },
  { id:"blue",color: "bg-blue-400", ring: "ring-blue-400",text: "text-blue-600" },
  { id:"yellow",color: "bg-yellow-400", ring: "ring-yellow-400",text: "text-yellow-600" },
  { id:"indigo",color: "bg-indigo-400", ring: "ring-indigo-400",text: "text-indigo-600" },
  { id:"pink",color: "bg-pink-400", ring: "ring-pink-400",text: "text-pink-600" },
  { id:"green",color: "bg-green-400", ring: "ring-green-400",text: "text-green-600" },
  { id:"lightblue",color: "bg-lightblue-400", ring: "ring-lightblue-400",text: "text-lightblue-600" },
  { id:"rose",color: "bg-rose-400", ring: "ring-rose-400",text: "text-rose-600" },
  { id:"orange",color: "bg-orange-400", ring: "ring-orange-400",text: "text-orange-600" }
  ,{ id:"fuchsia",color: "bg-fuchsia-400", ring: "ring-fuchsia-400",text: "text-fuchsia-600" },
  { id:"teal",color: "bg-teal-400", ring: "ring-teal-400",text: "text-teal-600" }


];

export default labelColors;
